"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapLinksToSearchQueries = void 0;
const mapLinksToSearchQueries = (links)=>{
    var _links_map_filter;
    return (_links_map_filter = links === null || links === void 0 ? void 0 : links.map((link)=>{
        var _link_title, _link_relativeUrl;
        return {
            text: (_link_title = link === null || link === void 0 ? void 0 : link.title) !== null && _link_title !== void 0 ? _link_title : '',
            url: (_link_relativeUrl = link === null || link === void 0 ? void 0 : link.relativeUrl) !== null && _link_relativeUrl !== void 0 ? _link_relativeUrl : ''
        };
    }).filter((query)=>query.text && query.url)) !== null && _links_map_filter !== void 0 ? _links_map_filter : [];
};
exports.mapLinksToSearchQueries = mapLinksToSearchQueries;
